import { render, staticRenderFns } from "./GetAdded.vue?vue&type=template&id=4f369795&scoped=true"
import script from "./GetAdded.vue?vue&type=script&lang=js"
export * from "./GetAdded.vue?vue&type=script&lang=js"
import style0 from "./GetAdded.vue?vue&type=style&index=0&id=4f369795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f369795",
  null
  
)

export default component.exports